/*** IMPORTS FROM imports-loader ***/
var define = false;

import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import VueResource from 'vue-resource'
import VueMaterial from 'vue-material'
import VueAnalytics from 'vue-analytics'
import VueCookie from 'vue-cookie'
import router from './router'
import store from './store'
import Api from '../generated'
import VueI18n from 'vue-i18n'
import en from './strings/en.js'
import hu from './strings/hu.js'
import generated_en from './strings/generated_en.js'
import generated_hu from './strings/generated_hu.js'
import moment from 'moment'
import VueLocalStorage from 'vue-localstorage'
import 'vue-event-calendar/dist/style.css' //^1.1.10, CSS has been extracted as one file, so you can easily update it.
import vueEventCalendar from 'vue-event-calendar'

// Load global css
import 'vue-material/dist/vue-material.css'
import 'vue-toast/dist/vue-toast.min.css'
import './css/flexboxgrid.css'
import 'c3/c3.min.css'
import './css/global.css'

Vue.use(VueResource)
Vue.use(VueMaterial)
Vue.use(Vuex)
Vue.use(VueI18n)
Vue.use(VueCookie)
Vue.use(VueLocalStorage)
Vue.use(vueEventCalendar, {locale: 'en'}) 

// Uncomment this to hide translated strings (and only show untranslated)
// Vue.config.i18nFormatter = function (string) {return "";}

// set lang
let storedLang = VueCookie.get('lang');

const messages = {
	"en": Object.assign(en, generated_en),
	"hu": Object.assign(hu, generated_hu)
};

const i18n = new VueI18n({
	locale: (storedLang ? storedLang : navigator.language.split("-",1)[0] || 'en'),
	fallbackLocale: 'en',
  	silentTranslationWarn: true,
	messages
})

Vue.material.registerTheme('default', {
	primary: 'deep-purple',
	accent: 'blue'
})

Api.ApiClient.instance = new Api.DefaultApi();
Api.ApiClient.instance.apiClient.enableCookies = true;

console.log(process.env.BACKEND);

if (process.env.BACKEND == 'local'){
	Api.ApiClient.instance.apiClient.basePath = "http://localhost:3000/api";
} else if (process.env.BACKEND == 'production'){
	Api.ApiClient.instance.apiClient.basePath = "https://pulmoment.com/api";
	// Setup analytics
	Vue.use(VueAnalytics, {
		id: 'UA-65390488-3',
		router
	})
} else {
	Api.ApiClient.instance.apiClient.basePath = "http://symbidev.cloudapp.net/api";
}

Api.ApiClient.instance.apiClient.defaultHeaders["languageId"] = i18n.locale;

// Create a global Event Bus
var EventBus = new Vue()

// Add to Vue properties by exposing a getter for $bus
Object.defineProperties(Vue.prototype, {
	$bus: {
		get: function () {
			return EventBus;
		}
	}
})

Vue.filter('formatDate', function(value) {
	if (value) {
		return moment(String(value)).format('YYYY.MM.DD. hh:mm')
	}
});

/* eslint-disable no-new */
const app = new Vue({
	i18n,
	router,
	store,
	render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js